import _Vue, {PluginObject} from 'vue';

const Email: PluginObject<any> = {
  install: (vue: typeof _Vue) => {
    vue.prototype.$validateEmail = (email: string) => {
      // Next line is disabled because this si an regex
      // tslint:disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };
  },
};

export default Email;
